var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "custom-callout",
        {
          staticClass: "mt-3",
          attrs: {
            "border-color": _vm.model.status?.color,
            controlled: "",
            "has-toggle": !_vm.isFromCompany,
            opened: _vm.isOpen
          },
          on: { "click:open": _vm.onOpenClose },
          scopedSlots: _vm._u([
            {
              key: "edition",
              fn: function() {
                return [
                  _c("div", { staticClass: "bg-secondary-3 p-2" }, [
                    _vm.isAdditionalInformation
                      ? _c(
                          "div",
                          { staticClass: "bg-white p-3 rounded mr-0 ml-0" },
                          [
                            _c("div", { staticClass: "row" }, [
                              _c("div", { staticClass: "col-12 mb-3" }, [
                                _c("i", {
                                  staticClass: "fas fa-info-circle text-orange"
                                }),
                                _c("strong", { staticClass: "ml-2" }, [
                                  _vm._v(" Información Adicional ")
                                ])
                              ])
                            ]),
                            _c("div", { staticClass: "row" }, [
                              _c("div", { staticClass: "col-12 col-lg-4" }, [
                                _c("div", { staticClass: "label" }, [
                                  _vm._v("Tipo de Proveedor:")
                                ]),
                                _c("div", { staticClass: "value" }, [
                                  _vm._v(_vm._s(_vm.model.companyType))
                                ])
                              ]),
                              _c("div", { staticClass: "col-12 col-lg-4" }, [
                                _c("div", { staticClass: "label" }, [
                                  _vm._v("Creado Por:")
                                ]),
                                _c("div", { staticClass: "value" }, [
                                  _vm._v(_vm._s(_vm.model.user))
                                ])
                              ]),
                              _c("div", { staticClass: "col-12 col-lg-4" }, [
                                _c("div", { staticClass: "label" }, [
                                  _vm._v("Fecha de Creación:")
                                ]),
                                _c("div", { staticClass: "value" }, [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm._f("date")(
                                          _vm.model.createdDate,
                                          "DD/MMM/YYYY"
                                        )
                                      ) +
                                      " "
                                  )
                                ])
                              ])
                            ])
                          ]
                        )
                      : _vm._e(),
                    _vm.isDenying
                      ? _c(
                          "div",
                          { staticClass: "row bg-white p-3 rounded mr-0 ml-0" },
                          [
                            _c("div", { staticClass: "col-12 my-3" }, [
                              _c("i", {
                                staticClass: "fas fa-times-circle text-red"
                              }),
                              _c("strong", { staticClass: "ml-2" }, [
                                _vm._v(" Denegar ")
                              ])
                            ]),
                            _c(
                              "div",
                              { staticClass: "col-12" },
                              [
                                _c("validation-provider", {
                                  attrs: {
                                    "custom-messages": {
                                      required: "El campo es requerido."
                                    },
                                    rules: "required"
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function({ errors, validate }) {
                                          return [
                                            _c("custom-text-area", {
                                              attrs: {
                                                "count-classes": [
                                                  "d-block",
                                                  "small-counter"
                                                ],
                                                "custom-error-msg": errors[0],
                                                error: errors[0],
                                                label: "Comentario:",
                                                maxlength: 3000,
                                                "show-char-count": ""
                                              },
                                              model: {
                                                value: _vm.statusComment,
                                                callback: function($$v) {
                                                  _vm.statusComment = $$v
                                                },
                                                expression: "statusComment"
                                              }
                                            }),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "text-right mt-4"
                                              },
                                              [
                                                _c(
                                                  "action-button",
                                                  {
                                                    staticClass: "mr-2",
                                                    attrs: {
                                                      i: "fas fa-times-circle",
                                                      variant: "outline-danger"
                                                    },
                                                    on: { click: _vm.onCancel }
                                                  },
                                                  [_vm._v(" Cancelar ")]
                                                ),
                                                _c(
                                                  "action-button",
                                                  {
                                                    attrs: {
                                                      i: "fas fa-save",
                                                      variant: "success"
                                                    },
                                                    on: {
                                                      click: () =>
                                                        _vm.changeStatus(
                                                          validate
                                                        )
                                                    }
                                                  },
                                                  [_vm._v(" Guardar ")]
                                                )
                                              ],
                                              1
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    false,
                                    3558034989
                                  )
                                })
                              ],
                              1
                            )
                          ]
                        )
                      : _vm.isViewHistory
                      ? _c(
                          "div",
                          { staticClass: "bg-white p-3 rounded" },
                          [
                            _c("medicaid-history", {
                              attrs: { item: _vm.model }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ])
                ]
              },
              proxy: true
            }
          ])
        },
        [
          _c("div", { staticClass: "row pt-2 ml-0 align-items-center" }, [
            _c(
              "div",
              { staticClass: "col-12 col-md-2 d-flex align-items-center" },
              [
                _c("custom-balloon", {
                  attrs: {
                    "background-color": _vm.model.status?.color,
                    dot: "",
                    text: _vm.model.status?.name
                  }
                })
              ],
              1
            ),
            !_vm.isFromCompany
              ? _c("div", { staticClass: "col-12 col-lg-2" }, [
                  _c("div", { staticClass: "label" }, [
                    _vm._v("Nombre del Proveedor:")
                  ]),
                  _c("div", { staticClass: "value" }, [
                    _vm._v(_vm._s(_vm.model.company))
                  ])
                ])
              : _vm._e(),
            !_vm.isFromCompany
              ? _c("div", { staticClass: "col-12 col-lg-2" }, [
                  _c("div", { staticClass: "label" }, [
                    _vm._v("Número de NPI:")
                  ]),
                  _c("div", { staticClass: "value" }, [
                    _vm._v(_vm._s(_vm.model.npi))
                  ])
                ])
              : _vm._e(),
            _c("div", { staticClass: "col-12 col-lg-2" }, [
              _c("div", { staticClass: "label" }, [_vm._v("Fecha Inicio:")]),
              _c("div", { staticClass: "value" }, [
                _vm._v(
                  _vm._s(_vm._f("date")(_vm.model.startDate, "DD/MMM/YYYY"))
                )
              ])
            ]),
            _c("div", { staticClass: "col-12 col-lg-2" }, [
              _c("div", { staticClass: "label" }, [_vm._v("Fecha Fin:")]),
              _c("div", { staticClass: "value" }, [
                _vm._v(_vm._s(_vm._f("date")(_vm.model.endDate, "DD/MMM/YYYY")))
              ])
            ]),
            _vm.isFromCompany
              ? _c("div", { staticClass: "col-12 col-lg-2" }, [
                  _c("div", { staticClass: "label" }, [_vm._v("Creado por:")]),
                  _c("div", { staticClass: "value" }, [
                    _vm._v(_vm._s(_vm.model.user))
                  ])
                ])
              : _vm._e(),
            _vm.isFromCompany
              ? _c("div", { staticClass: "col-12 col-lg-2" }, [
                  _c("div", { staticClass: "label" }, [
                    _vm._v("Fecha de Creación:")
                  ]),
                  _c("div", { staticClass: "value" }, [
                    _vm._v(
                      _vm._s(
                        _vm._f("date")(_vm.model.createdDate, "DD/MMM/YYYY")
                      )
                    )
                  ])
                ])
              : _vm._e(),
            _c(
              "div",
              {
                staticClass: "col-12",
                class: {
                  "col-lg-1": _vm.isSubmitted && _vm.checkable,
                  "col-lg-2": !(_vm.isSubmitted && _vm.checkable)
                }
              },
              [
                _c("drop-down", {
                  attrs: { "data-item": _vm.model, items: _vm.availableActions }
                })
              ],
              1
            ),
            _vm.checkable && _vm.isSubmitted
              ? _c("div", { staticClass: "col-12 col-lg-1" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-flex justify-content-center align-items-center h-100"
                    },
                    [
                      _c("checkbox", {
                        staticClass: "d-flex justify-content-center",
                        attrs: {
                          "checked-bg-color": "bg-success",
                          icon: "fal fa-check"
                        },
                        on: {
                          input: function($event) {
                            return _vm.check(_vm.model)
                          }
                        },
                        model: {
                          value: _vm.model.checked,
                          callback: function($$v) {
                            _vm.$set(_vm.model, "checked", $$v)
                          },
                          expression: "model.checked"
                        }
                      })
                    ],
                    1
                  )
                ])
              : _vm._e()
          ])
        ]
      ),
      _vm.alertUpcomingExpirationDateText && !_vm.alertExpiredDateText
        ? _c("custom-error", {
            attrs: {
              "is-alert-mode": "",
              message: _vm.alertUpcomingExpirationDateText,
              variant: "mt-0 border-top-0"
            }
          })
        : _vm._e(),
      _vm.alertExpiredDateText
        ? _c("custom-error", {
            attrs: {
              message: _vm.alertExpiredDateText,
              variant: "mt-0 border-top-0"
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }